import React, { useState, useCallback } from 'react';
import { Upload, Toast } from '@roo/roo';
import { FileModel } from '@roo/roo/Upload';
import './index.scss';

interface ImageUploaderProps {
    defaultUrl?: string;
}

const readURL = (file: File) =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = e => resolve(e.target!.result as string);
        reader.onerror = e => reject(e);
        reader.readAsDataURL(file);
    }) as Promise<string>;

const maxMB = 10;
const maxSize = maxMB * 1024 * 1024;

const ImageUploader: React.FC<ImageUploaderProps> = ({ defaultUrl }) => {
    const [imageSrc, setImageSrc] = useState(defaultUrl);

    const validate = useCallback((currentFiles: FileModel[]) => {
        if (currentFiles.some(file => file.size > maxSize)) {
            Toast.open({
                title: `文件不能大于${maxMB}M`,
            });
            return false;
        }
        return true;
    }, []);

    return (
        <Upload
            name="img"
            action="/api/serviceProvider/logo/upload"
            onSuccess={(res: any, { _fileObj }) => {
                // `res` 实际返回的不是 `Response` 类型啊...
                if (res?.code === 0) {
                    const imgSrc = res?.data?.img;
                    if (imgSrc) {
                        setImageSrc(imgSrc);
                    } else if (_fileObj) {
                        readURL(_fileObj).then(setImageSrc);
                    }
                }
            }}
            onFail={(error: Error) => {
                Toast.open({
                    title: error.message,
                });
            }}
            validityCallback={validate}
        >
            <div className="account-image-container">
                {imageSrc ? (
                    <img alt="account-icon" src={imageSrc} />
                ) : (
                    <span className="account-icon-add-tip">上传文件</span>
                )}
                <div className="account-image-mask">{imageSrc ? '重新上传文件' : '上传文件'}</div>
            </div>
        </Upload>
    );
};

export default ImageUploader;
